import React, { useState } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { AntTabs, AntTab, StyledTableCell, StyledTableRow} from '../tabs_style';
import Paper from '@mui/material/Paper';
import { TablePagination, Card, CardContent, Container, Stack, Grid, Box, FormControl, TextField, InputAdornment } from "@mui/material";
import { Tabs, Tab } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';

export default function CalculosROAnterior() {
  const [tabIndex, setTabIndex] = React.useState(3);
  const navigate = useNavigate();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const handleChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  const rows = [
    {
      mes: "", año: "", sueldo: "", sdiario: "", blanco1: "", blanco2: "", siete: "", blanco3: "", blanco4: "",
      blanco5: "", blanco6: "", pagar: "", rebaja: "", dias: "", rebajalps: ""
    },
    {
      mes: "", año: "", sueldo: "", sdiario: "", blanco1: "", blanco2: "", siete: "", blanco3: "", blanco4: "",
      blanco5: "", blanco6: "", pagar: "", rebaja: "", dias: "", rebajalps: ""
    },
    {
      mes: "", año: "", sueldo: "", sdiario: "", blanco1: "", blanco2: "", siete: "", blanco3: "", blanco4: "",
      blanco5: "", blanco6: "", pagar: "", rebaja: "", dias: "", rebajalps: ""
    },
  ];

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <>
      <Grid container direction="column" alignItems="center">
        <Container>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <h2>Cálculos</h2>
          </div>
        </Container>
        <Container>
          <Box sx={{ position: 'sticky', top: 0, zIndex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Paper square>
              <AntTabs
                value={tabIndex}
                onChange={handleChange}
                indicatorColor="primary"
                textColor="primary"
                variant="scrollable"
                scrollButtons="auto"
                TabIndicatorProps={{
                  style: { display: 'none' }, // O también puedes usar display: 'none' aquí
              }}
              >
                <AntTab label="Resumen" />
                <AntTab label="Tabla De Interés" />
                <AntTab label="Datos" />
                <AntTab label="Cálculos" />
                <AntTab label="Períodos" />
                <AntTab label="Rebajas" />
                <AntTab label="Comparativa Devolución 10%" />
                <AntTab label="Finiquito y Dictamen" />
              </AntTabs>
            </Paper>
          </Box>

          <Box mt={3}>
            {/* Contenido de la pestaña actual */}
            {tabIndex === 0 && navigate('Separaciones/ResumenROAnterior')}
            {tabIndex === 1 && navigate('Separaciones/TablaDeInteresROAnterior')}
            {tabIndex === 2 && navigate('/Separaciones/ROantes13demayo2014')}
            {tabIndex === 3}
            {tabIndex === 4 && navigate('/Separaciones/PeriodosROAnterior')}
            {tabIndex === 5 && navigate('/Separaciones/RebajasROAnterior')}
            {tabIndex === 6 && navigate('/Separaciones/ComparativaROAnterior')}
            {tabIndex === 7 && navigate('/Separaciones/FiniquitoROAnterior')}
          </Box>
        </Container>
      </Grid>

      <Box marginTop={2} boxShadow={2}>
        <Card variant='outlined'>
          <CardContent>

            <Stack direction="row">
              <Grid container spacing={1}>
                <FormControl sx={{ m: 1, flexGrow: 1 }}>
                  <TextField
                    id="nombre"
                    label="Nombre Correcto"
                    variant="outlined"
                    InputProps={{ readOnly: true }}
                  />
                </FormControl>
                <FormControl sx={{ m: 1, flexGrow: 1 }}>
                  <TextField
                    id="nocotizante"
                    label="No. Cotizante"
                    variant="outlined"
                    InputProps={{ readOnly: true }}
                  />
                </FormControl>
              </Grid>
            </Stack>

            <Stack direction="row" marginTop={1}>
              <Grid container spacing={1}>
                <FormControl sx={{ m: 1, flexGrow: 1 }}>
                  <TextField
                    id="suma"
                    label="SUMA"
                    variant="outlined"
                    InputProps={{ startAdornment: <InputAdornment position="start">L.</InputAdornment>, readOnly: true }}
                  />
                </FormControl>
                <FormControl sx={{ m: 1, flexGrow: 1 }}>
                  <TextField
                    id="sistema"
                    label="SISTEMA"
                    variant="outlined"
                    InputProps={{ startAdornment: <InputAdornment position="start">L.</InputAdornment>, readOnly: true }}
                  />
                </FormControl>
              </Grid>
            </Stack>

            <Stack direction="row" marginTop={1}>
              <Grid container spacing={1}>
                <FormControl sx={{ m: 1, flexGrow: 1 }}>
                  <TextField
                    id="difcot"
                    label="DIF- EN COT"
                    variant="outlined"
                    InputProps={{ startAdornment: <InputAdornment position="start">L.</InputAdornment>, readOnly: true }}
                  />
                </FormControl>
                <FormControl sx={{ m: 1, flexGrow: 1 }}>
                  <TextField
                    id="difsueldo"
                    label="DIF- EN SUELDO"
                    variant="outlined"
                    InputProps={{ startAdornment: <InputAdornment position="start">L.</InputAdornment>, readOnly: true }}
                  />
                </FormControl>
                <FormControl sx={{ m: 1, flexGrow: 1 }}>
                  <TextField
                    id="rebajas"
                    label="REBAJAS"
                    variant="outlined"
                    InputProps={{ startAdornment: <InputAdornment position="start">L.</InputAdornment>, readOnly: true }}
                  />
                </FormControl>
              </Grid>
            </Stack>

          </CardContent>
        </Card>
      </Box>

      <div>
        <TableContainer component={Paper} style={{ marginTop: 30 }}>
          {/* Tabla 2 */}
          <Table>
            <TableHead>
              <StyledTableRow>
                <StyledTableCell style={{ textAlign: 'center', whiteSpace: 'normal' }}><strong>MES</strong></StyledTableCell>
                <StyledTableCell style={{ textAlign: 'center' }}><strong>AÑO</strong></StyledTableCell>
                <StyledTableCell style={{ textAlign: 'center' }}><strong>SUELDO</strong></StyledTableCell>
                <StyledTableCell style={{ textAlign: 'center' }}><strong>SDIARIO</strong></StyledTableCell>
                <StyledTableCell style={{ textAlign: 'center' }}><strong></strong></StyledTableCell>
                <StyledTableCell style={{ textAlign: 'center' }}><strong></strong></StyledTableCell>
                <StyledTableCell style={{ textAlign: 'center' }}><strong>7%</strong></StyledTableCell>
                <StyledTableCell style={{ textAlign: 'center' }}><strong></strong></StyledTableCell>
                <StyledTableCell style={{ textAlign: 'center' }}><strong></strong></StyledTableCell>
                <StyledTableCell style={{ textAlign: 'center' }}><strong></strong></StyledTableCell>
                <StyledTableCell style={{ textAlign: 'center' }}><strong></strong></StyledTableCell>
                <StyledTableCell style={{ textAlign: 'center' }}><strong>PAGAR</strong></StyledTableCell>
                <StyledTableCell style={{ textAlign: 'center' }}><strong>REBAJA 7%</strong></StyledTableCell>
                <StyledTableCell style={{ textAlign: 'center' }}><strong>DÍAS</strong></StyledTableCell>
                <StyledTableCell style={{ textAlign: 'center' }}><strong>REBAJA LPS</strong></StyledTableCell>
              </StyledTableRow>
            </TableHead>
            <TableBody>
              {(rowsPerPage > 0
                ? rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                : rows
              ).map((row) => (
                <StyledTableRow key={row.id}>
                  <StyledTableCell style={{ textAlign: 'center', fontSize: 17 }}>{row.mes}</StyledTableCell>
                  <StyledTableCell style={{ textAlign: 'center', fontSize: 17 }}>{row.año}</StyledTableCell>
                  <StyledTableCell style={{ textAlign: 'center', fontSize: 17 }}>{row.sueldo}</StyledTableCell>
                  <StyledTableCell style={{ textAlign: 'center', fontSize: 17 }}>{row.sdiario}</StyledTableCell>
                  <StyledTableCell style={{ textAlign: 'center', fontSize: 17 }}><TextField variant='filled' style={{ minWidth: 94 }} /></StyledTableCell>
                  <StyledTableCell style={{ textAlign: 'center', fontSize: 17 }}>{row.blanco2}</StyledTableCell>
                  <StyledTableCell style={{ textAlign: 'center', fontSize: 17 }}>{row.siete}</StyledTableCell>
                  <StyledTableCell style={{ textAlign: 'center', fontSize: 17 }}>{row.blanco3}</StyledTableCell>
                  <StyledTableCell style={{ textAlign: 'center', fontSize: 17 }}><TextField variant='filled' style={{ minWidth: 94 }} /></StyledTableCell>
                  <StyledTableCell style={{ textAlign: 'center', fontSize: 17 }}><TextField variant='filled' style={{ minWidth: 94 }} /></StyledTableCell>
                  <StyledTableCell style={{ textAlign: 'center', fontSize: 17 }}><TextField variant='filled' style={{ minWidth: 94 }} /></StyledTableCell>
                  <StyledTableCell style={{ textAlign: 'center', fontSize: 17 }}>{row.pagar}</StyledTableCell>
                  <StyledTableCell style={{ textAlign: 'center', fontSize: 17 }}>{row.rebaja}</StyledTableCell>
                  <StyledTableCell style={{ textAlign: 'center', fontSize: 17 }}>{row.dias}</StyledTableCell>
                  <StyledTableCell style={{ textAlign: 'center', fontSize: 17 }}>{row.rebajalps}</StyledTableCell>
                </StyledTableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 20]}
          component="div"
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </div>
    </>
  );
}